import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Browsers keep the scroll position when the URL changes without a document
 * load, so moving from the project list to a project would otherwise open the
 * new page halfway down.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
